export const renderTextWithLink = (text) => {
    if (typeof text !== "string" || !text) return text;

    const urlRegex = /(https?:\/\/[^\s<>()]+)/g;

    return text.replace(urlRegex, (match) => {
        const cleaned = match.replace(/[.,!?;:]+$/, "");
        const trailing = match.slice(cleaned.length);

        try {
            const u = new URL(cleaned);

            let number = null;
            if (u.hash) {
                const m = decodeURIComponent(u.hash).match(/:~:text=(\d+)/);
                number = m ? m[1] : null;
            }

            const newHash = number ? `#:~:text=${number}` : "";

            const display = `${u.origin}${u.pathname}${newHash}`;

            return `<a href="${u}" target="_blank" rel="noopener noreferrer"> ${display} </a>${trailing}`;
        } catch {
            return match;
        }
    });
};